<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <!-- <el-input size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input> -->
            </div>
            <div class="BtnHead">
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="DownLog">导出日志</el-button>
                <el-button v-throttle size="small" type="danger" @click="Clear">清空日志</el-button>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading">
            <el-table-column prop="id" label="ID" min-width="50"></el-table-column>
            <el-table-column prop="admin_name" label="操作人名称"></el-table-column>
            <el-table-column prop="admin_username" label="操作人账号"></el-table-column>
            <el-table-column prop="module" label="操作模块" min-width="100"></el-table-column>
            <el-table-column prop="action" label="操作名称" min-width="100"></el-table-column>
            <el-table-column prop="method" label="请求方法"></el-table-column>
            <el-table-column prop="ip" label="操作IP" min-width="100"></el-table-column>
            <el-table-column prop="url" label="操作地址" min-width="100"></el-table-column>
            <el-table-column prop="route" label="操作路由" min-width="100"></el-table-column>
            <el-table-column prop="status_code" label="操作状态"></el-table-column>
            <el-table-column prop="execute_time" label="执行时间（毫秒）" min-width="100"></el-table-column>
            <el-table-column prop="create_time" label="操作时间"></el-table-column>
           <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="删除" placement="top-start">                          <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol">
        </el-pagination>
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                loading:false,
                SearchVal:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
            };
        },
        mounted() {
            this.GetData();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/operationlog/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            DownLog(){
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    this.$get('/admin/operationlog/export').then(res=>{
                        loading.close();
                        if(res){
                            window.open(res.data.download_url)
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            Delete(id) {
                this.$confirm("此操作将删除此条数据, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$post('/admin/operationlog/delete',{
                        ids:[id],
                    }).then(res=>{
                        if(res){
                            this.$message.success("删除成功!");
                            this.GetData();
                        }
                    })
                })
            },
            Clear() {
                this.$confirm("此操作将清空日志, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$post('/admin/operationlog/clear',{
                        days: 30,
                    }).then(res=>{
                        if(res){
                            this.$message.success(res.msg);
                            this.GetData();
                        }
                    })
                })
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    
</style>
